import AbstractFileInput from './AbstractFileInput';

export default class Image extends AbstractFileInput {

    constructor() {
        super();
    }

    getAllowedFileTypes() {
        return ['image'];
    }

    getFileTypeSettings() {
        return {
            image: function (vType, vName) {
                return vType.match('image.*');
            },
        };
    }
}
